import { BaseApi } from '@/main/baseApi';

import { MODULE_API } from '../constants';
import { NAME, ND_PRIJEMKA } from './constants';

class EdlProvider extends BaseApi {
	createFromFile(file: any) {
		return this.post(`${this.apiPath}ProcessEdlFileToDb`, file);
	}

	tableSchemaDataUrl(tableName: string) {
		return `${this.area}/${ND_PRIJEMKA}/GetNDPrijemkaByEdlSchemaAndRows`;
	}
}

export const apiProvider = new EdlProvider(MODULE_API, NAME);
